const RELATED_KEY = "ISP_PRODUCTS_VIEWED_SESSION_2";
const PRODUCT_EXPIRY_DAYS = 5
type Product = [number, number, string | null]

export default function getRecentProducts(){
    if(RELATED_KEY in localStorage){
        const products = JSON.parse(localStorage.getItem(RELATED_KEY)) as Product[];
        const currentTimestamp = Date.now() / 1000;
        const expiryTimestamp   = currentTimestamp - (PRODUCT_EXPIRY_DAYS * 24 * 60 * 60);

        const recentProducts = products.filter(([_, timestamp]) => timestamp >= expiryTimestamp);
        const productsArray = recentProducts.sort((a,b) => b[1] < a[1] ? 1 : -1).map(p => String(p[0]));
        return [...new Set(productsArray)];
    }

    return [];
}